import { Component, OnInit, NgZone } from "@angular/core";
import { AppConfigService } from "../core/services/app-config.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "nf-modal",
  template: `
    <div
      id="acn-modal"
      [attr.data-widgetid]="component.WIDGET_ID"
      [attr.data-appid]="config.APP_ID"
    ></div>
    <link rel="stylesheet" [href]="CSS_SCRIPT" />
  `,
  //template: `<div></div>  `,
  styles: [],
})
export class ModalComponent implements OnInit {
  CSS_SCRIPT;
  config;
  component;
  constructor(
    config: AppConfigService,
    private sanitizer: DomSanitizer,
    private zone: NgZone
  ) {
    this.config = config.getConfig()[`notification`];
  }

  ngOnInit(): void {
    this.component = this.config.modal;

    this.CSS_SCRIPT = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.component.CSS_SCRIPT
    );
    setTimeout(this.appendScript, 100);
  }
  private appendScript = (src) => {
    this.zone.runOutsideAngular(() => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = this.component.SRC_SCRIPT;
      document.body.appendChild(script);
    });
  };
}
